<dv-loading-button
    class="tabellarische-maske-button"
    (buttonClick)="openDialog()"
    [buttonDisabled]="buttonDisabled"
    >{{ 'OPEN_TABELLARISCHE_MASKE' | translate }}</dv-loading-button
>
